import { PHASE } from "../../../common/constants.ts";
import type { EventBBGM } from "../../../common/types.ts";
import { idb } from "../../db/index.ts";
import { PlayersCache } from "../../db/PlayersCache.ts";
import { formatEventText } from "../../util/formatEventText.ts";

export const isOffseasonTransaction = (
	eventSeason: number,
	phase: number | undefined,
	season: number,
) =>
	phase !== undefined &&
	((eventSeason === season - 1 && phase >= PHASE.DRAFT_LOTTERY) ||
		(eventSeason === season && phase === PHASE.PRESEASON));

export const getOffseasonChanges = async (season: number) => {
	const events = [
		...(await idb.getCopies.events({ season: season - 1 })),
		...(await idb.getCopies.events({ season })),
	];
	const players = new PlayersCache();
	const changes: {
		eid: number;
		text: string;
		isWatchList: boolean;
		ovr: number;
		score: number;
		type: EventBBGM["type"];
	}[] = [];
	for (const event of events) {
		if (!["freeAgent", "reSigned", "trade", "draft", "expansionDraft"].includes(event.type)) {
			continue;
		}
		let phase = "phase" in event ? event.phase : undefined;
		let isWatchList = false;
		let ovr = 0;
		for (const pid of event.pids ?? []) {
			const p = await players.get(pid);
			if (!p) continue;
			isWatchList ||= !!p.watch;
			// Use the report season's ratings, including retired players on disk.
			const ratings = p.ratings.findLast((row) => row.season <= season);
			ovr = Math.max(ovr, ratings?.ovr ?? 0);
			phase ??= p.transactions?.find((tx) => tx.eid === event.eid)?.phase;
		}
		if (event.type === "reSigned") phase ??= PHASE.RESIGN_PLAYERS;
		if (event.type === "draft" && event.season === season - 1) {
			if (!isWatchList && phase !== PHASE.EXPANSION_DRAFT) continue;
		} else if (!isOffseasonTransaction(event.season, phase, season)) {
			continue;
		}
		changes.push({
			eid: event.eid,
			text: await formatEventText(event),
			isWatchList,
			ovr,
			score: event.score ?? 0,
			type: event.type,
		});
	}
	return changes;
};
